/* Font style module */

const font = {
  family: {
    serif: 'DroidSerif', // not used for now
    sans: 'noto-sans-display, aktiv-grotesk, sans-serif',
  },
  size: {
    extraSmall: '0.7rem',
    small: '0.8rem',
    caption: '0.9rem',
    body: '1rem', // base = 14px, ratio = minor third, 1.2
    title: '1.2rem',
    headline: '1.4rem', // icons on 2d/3d maps
    display: '1.7rem',
    large: '2.1rem',
    jumbo: '2.5rem',
    mega: '3rem',
    giga: '3.6rem',
  },
  weight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

export default font;
